var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.4801 20.629C20.342 20.629 20.2126 20.5765 20.1154 20.4811L14.2459 14.7161L13.6644 15.1343C12.2972 16.1174 10.6725 16.637 8.96611 16.637C6.83781 16.637 4.83725 15.8238 3.33277 14.3475C1.82857 12.8706 1 10.9072 1 8.81835C1 6.72954 1.82857 4.76608 3.33277 3.28951C4.83725 1.8132 6.83781 1 8.96611 1C11.0944 1 13.095 1.8132 14.5994 3.28951C16.1039 4.76581 16.9322 6.72954 16.9322 8.81835C16.9322 10.4876 16.4025 12.0827 15.4003 13.4309L14.9765 14.0008L20.8448 19.7647C21.0462 19.9624 21.0462 20.2835 20.8448 20.4809C20.7476 20.5763 20.6179 20.6288 20.4801 20.6288V20.629ZM8.96611 2.01004C5.1409 2.01004 2.02913 5.06437 2.02913 8.81835C2.02913 12.5723 5.14118 15.6267 8.96611 15.6267C12.791 15.6267 15.9031 12.5723 15.9031 8.81835C15.9031 5.06437 12.7913 2.01004 8.96611 2.01004Z",
    fill: "black",
    stroke: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.90801702b2330e2c6af5831117f3c302.svg";
export { ForwardRef as ReactComponent };